import React, { useMemo } from "react";
import { ChalkboardEvent, SUBTYPE } from "../utils";
import { getBorderColorForEvent } from "../helper";

type Props = {
  events: ChalkboardEvent[];
  status: any;
};

const isDistributionSubtype = (sub: number) =>
  sub === SUBTYPE.SuccessfulPasses ||
  sub === SUBTYPE.UnsuccessfulPasses ||
  sub === SUBTYPE.SuccessfulCrosses ||
  sub === SUBTYPE.UnsuccessfulCrosses ||
  sub === SUBTYPE.KeyPasses ||
  sub === SUBTYPE.Assists;

export const DistributionPaths: React.FC<Props> = ({ events }) => {
  const distro = useMemo(
    () =>
      events.filter(
        (e) => e.category === "Distribution" && isDistributionSubtype(e.subtype)
      ),
    [events]
  );

  const withTargets = distro.filter((e) => e.tx != null && e.ty != null);
  if (!withTargets.length) return null;

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      style={{ position: "absolute", inset: 0, pointerEvents: "none" }}
    >
      {withTargets.map((e) => {
        const x1 = (e.x ?? 0) * 100;
        const y1 = (e.y ?? 0) * 100;
        const x2 = (e.tx ?? e.x ?? 0) * 100;
        const y2 = (e.ty ?? e.y ?? 0) * 100;

        const strokeClass = getBorderColorForEvent(e);

        return (
          <React.Fragment key={`distro-line-${e.id}`}>
            <defs>
              <marker
                id={`distro-arrow-${e.id}`}
                markerWidth="4"
                markerHeight="4"
                refX="2.8"
                refY="2"
                orient="auto"
                markerUnits="strokeWidth"
              >
                <path
                  d="M0,0 L0,4 L4,2 Z"
                  className={strokeClass}
                  fill="currentColor"
                />
              </marker>
            </defs>
            <line
              x1={x1}
              y1={y1}
              x2={x2}
              y2={y2}
              className={strokeClass}
              stroke="currentColor"
              strokeWidth="0.5vw"
              vectorEffect="non-scaling-stroke"
              markerEnd={`url(#distro-arrow-${e.id})`}
            />
          </React.Fragment>
        );
      })}
    </svg>
  );
};
